import React, { useEffect, useState } from "react";
import { Layer, useTheme } from "thorium-ui";
import getGitHubStats from "../../utils/getGitHubStats";
import getNpmStats from "../../utils/getNpmStats";
import { StatsBadge } from "./StatsBadge";

export const StatsBox = () => {
   const theme = useTheme();
   const [npmStats, setNpmStats] = useState(null);
   const [npmDownloads, setNpmDownloads] = useState(null);
   const [githubStats, setGithubStats] = useState(null);
   const [packages] = useState([
      "thorium-ui",
      "color-coded-code",
      "canvas-snowstorm",
      "domain-destroyer"
   ]);

   useEffect(() => {
      const getNpmData = async () => {
         setNpmStats(await getNpmStats(packages));
      };
      getNpmData();
   }, [packages]);

   useEffect(() => {
      const getGithubData = async () => {
         setGithubStats(await getGitHubStats());
      };
      getGithubData();
   }, [packages]);

   // Track fetch requests made (avoid rate limiting if problem arises)

   useEffect(() => {
      if (npmStats) {
         let downloadCount = 0;
         for (const pkg of packages) {
            downloadCount += npmStats[pkg].downloads;
         }
         setNpmDownloads(downloadCount);
      }
   }, [npmStats, packages]);

   const badges = [
      {
         data: "Hacktoberfest",
         logoColor: "none",
         name: "hacktoberfest",
         title: `Hacktoberfest 2020 Contributor`,
         unit: "2020 Contributor"
      },
      {
         data: "IT Support Professional",
         logoColor: "none",
         name: "googleIT",
         title: `Google IT Support Professional Certificate`,
         unit: "Google Certified"
      },
      {
         data: `${(npmDownloads / 1000).toFixed(1)}k`,
         icon: "im-download",
         logoColor: "#cc3534",
         name: "npm",
         title: `My npm packages have been downloaded ${npmDownloads} times!`,
         unit: "Downloads"
      },
      {
         data: githubStats,
         logoColor: theme.body.color,
         name: "git",
         title: `I've contributed to ${githubStats} public GitHub repos!`,
         unit: "Public Repos"
      }
   ];

   return (
      <Layer justify="center" className="mx-0 stats-box">
         {badges.map((badge, ind) => (
            <StatsBadge
               data={badge.data}
               key={ind}
               logoColor={badge.logoColor}
               name={badge.name}
               title={badge.title}
               unit={badge.unit}
            />
         ))}
      </Layer>
   );
};

export default StatsBox;
